import { withInstall } from "../../utils/install";
import Monitor from "./src/main.vue";

export const ltMonitor = withInstall(Monitor);
export default ltMonitor;